import { OnSiteApi } from "../../apis/onsite";
import { useMutation } from "@tanstack/react-query";
import { Response } from "../../models/response";
import HttpClient from "../../utils/network";
import { twclsx } from "../../utils/cssUtil";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RemoveSessionToken } from "../../utils/store";
import { currentArtistAtom } from "../../atoms/artistAtom";
import { useSetAtom } from "jotai";

export function Logout() {
  const navigate = useNavigate();
  const { mutateAsync: logoutMutation, isPending } = useMutation({
    mutationFn: async () => {
      new Response(await HttpClient.request(OnSiteApi.logout()));
      setCurrentArtist(undefined);
    },
  });
  const { t } = useTranslation();
  const setCurrentArtist = useSetAtom(currentArtistAtom);

  const logout = async () => {
    try {
      await logoutMutation();
    } catch (e) {
      console.error(`${e}`);
    }
    RemoveSessionToken();
    navigate("/login");
  };

  return (
    <>
      <button
        className={twclsx("btn btn-ghost", isPending && "btn-disabled")}
        onClick={logout}
      >
        {isPending ? (
          <span className={"loading loading-spinner"}></span>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z"
              clipRule="evenodd"
            />
          </svg>
        )}
        {t("sidemenu_logout")}
      </button>
    </>
  );
}
